import { USER_MANAGEMENT } from './const';

const PAYMENT_ERROR_MESSAGES = {  EXISTING_SUBSCRIPTION_USE_UPDATE: 'You already have a subscription. Use the plan cards below to change plan or add-ons.',
};

export const getPaymentErrorMessage = (error) => {
  const code = error?.response?.data?.message;
  if (code && PAYMENT_ERROR_MESSAGES[code]) {
    return PAYMENT_ERROR_MESSAGES[code];
  }
  return error?.response?.data?.message || error?.message || 'Unable to start checkout.';
};

export const redirectToStripeCheckout = async (postData, payload, stripe) => {
  const response = await postData(USER_MANAGEMENT.SUBSCRIPTION_PAYMENT, payload);
  if (response?.url) {
    window.location.assign(response.url);
    return;
  }
  if (response?.id && stripe) {
    const { error } = await stripe.redirectToCheckout({ sessionId: response.id });
    if (error) {
      throw error;
    }
    return;
  }
  throw new Error('Stripe checkout session was not returned.');
};
